import logEvent from './log-event';
import {
  getAllowedContentCountWithoutAccount,
  getContentCountToStartRenderingBannerNotificatons,
  getFilteredAccountGateData,
  localStorageEnabled,
} from '../../pages/slideview/content-account-gate-common';

export const getSlideshowViewEventOptions = () => {
  const slideshow = window.slideshare_object.slideshow;
  return {
    slideshow_id: slideshow.id,
    slideshow_created_at: slideshow.created_at,
    slideshow_category: slideshare_object.gam_cat_name,
    slideshow_language: slideshow.language,
    slideshow_format: slideshow.type,
    source: 'slideshow_view',
  };
};

const tabMap = {
  '#comments-panel': 'comments',
  '#likes-panel': 'likes',
  '#downloads-panel': 'downloads',
  '#stats-panel': 'stats',
  '#notes-panel': 'notes',
};

function logShareInteractedEvent(source) {
  const options = $.extend({}, getSlideshowViewEventOptions(), {
    social: source,
  });
  logEvent('slideshow_share_interacted', options);
}

const getViewRestrictionState = () => {
  if (!localStorageEnabled()) {
    return 'unrestricted';
  }

  const filteredData = getFilteredAccountGateData();
  const contentLimitForRestriction = getAllowedContentCountWithoutAccount();
  const contentLimitForBanner =
    contentLimitForRestriction -
    getContentCountToStartRenderingBannerNotificatons();
  const currentCount = filteredData.length;

  if (currentCount < contentLimitForBanner) {
    return 'unrestricted';
  } else if (
    currentCount >= contentLimitForBanner &&
    currentCount < contentLimitForRestriction
  ) {
    return 'warning';
  } else {
    return 'restricted';
  }
};

const logSlideshowViewed = () => {
  const options = $.extend({}, getSlideshowViewEventOptions(), {
    slideshow_num_pages: window.slideshare_object.slideshow.total_slides,
    view_restriction_state: getViewRestrictionState(),
  });
  logEvent('slideshow_viewed', options);
};

const bindEventListeners = () => {
  $('.facebook .share-link').click(function () {
    logShareInteractedEvent('facebook');
  });

  $('.twitter .share-link').click(function () {
    logShareInteractedEvent('twitter');
  });

  $('.linkedin .share-link').click(function () {
    logShareInteractedEvent('linkedin');
  });

  $('.j-share-embed').click(function () {
    logShareInteractedEvent('embed');
  });

  $('.wordpress-container').click(function () {
    logShareInteractedEvent('wordpress');
  });

  $('.share-link-container').click(function () {
    logShareInteractedEvent('link');
  });

  $('.slideshow-action .share').click(function () {
    logEvent('slideshow_share_initiated', getSlideshowViewEventOptions());
  });

  $('.clip-button-top').click(function () {
    logEvent('slideshow_clipped', getSlideshowViewEventOptions());
  });

  $('#mobile-clip-button').click(function () {
    logEvent('slideshow_clipped', getSlideshowViewEventOptions());
  });

  $('.clipping-indicator.top-clip').click(function () {
    logEvent('slideshow_jumped_to_clip', getSlideshowViewEventOptions());
  });
};

export const initializeSlideshowEvents = () => {
  window.addEventListener('DOMContentLoaded', () => {
    bindEventListeners();
    logSlideshowViewed();
  });
}
